module.exports = __webpack_public_path__ + "img/91.f520d449.png";